<template>
  <div class="content">
    <div class="upload-btn">
      <div class="input-file">
        <input type="file" ref="files" @change="changeImage" multiple />
        <el-button type="primary">
          <div class="button-content">
            <svg class="svg-icon" aria-hidden="true">
              <use xlink:href="#icon-cross"></use>
            </svg>
            上传图片
            <svg class="svg-icon" aria-hidden="true">
              <use xlink:href="#icon-picture"></use>
            </svg>
          </div>
        </el-button>
      </div>
      <span class="pic-total">{{ list.length }}/20</span>
    </div>
    <p class="batch-operate" v-if="!isOperate">
      <svg class="svg-icon" aria-hidden="true">
        <use xlink:href="#icon-upload"></use>
      </svg>
      <a @click="checkOperate">操作</a>
    </p>
    <p class="batch-operate operate-img" v-else>
      <a class="select-all" @click="selectAll">全选</a>
      <a class="cancel" @click="checkOperate">取消</a>
      <svg class="svg-icon" aria-hidden="true" @click="deleteImg">
        <use xlink:href="#icon-delete"></use>
      </svg>
    </p>
    <div class="list">
      <div v-for="item in list" :key="item.id">
        <el-checkbox
          v-if="isOperate"
          label=""
          :value="checkedList.includes(item.id)"
          @change="e => selectPic(e, item.id)"
        ></el-checkbox>
        <img
          :src="item.image_url"
          @click="loadTemplate($event, item.image_url)"
          alt=""
          draggable="true"
          @dragend="dragend"
          @dragstart="dragstart($event, item.image_url)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import uploadMinxis from 'components/upload/uploadMinxis';
import upload from 'mixins/upload';

export default {
  components: {},
  props: ['canvasWidth', 'canvasHeight'],
  mixins: [upload, uploadMinxis],
  data() {
    return {
      namespace: 'userMaterial',
      image: null,
      isOperate: false,
      checkedList: [],
      isSelectAll: false
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.$store.dispatch(this.namespace + '/fetch');
    },
    checkOperate() {
      this.isOperate = !this.isOperate;
      this.isSelectAll = false;
      this.checkedList = [];
    },
    selectAll() {
      if (this.isSelectAll) {
        this.checkedList = [];
      } else {
        this.checkedList = this.list.map(list => list.id);
      }
      this.isSelectAll = !this.isSelectAll;
    },
    selectPic(value, id) {
      if (value) {
        this.checkedList = this.checkedList.concat([id]);
      } else {
        this.checkedList = this.checkedList.filter(item => id !== item);
      }
    },
    deleteImg() {
      if (!this.checkedList.length) {
        this.$message.warn('请选择要删除的图片');
        return;
      }

      this.$confirm('确认要删除选中的图片？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          this.$store
            .dispatch(this.namespace + '/delete', { ids: this.checkedList })
            .then(res => {
              this.$message.success('success');
              this.fetchData();
            });
        })
        .catch(() => {
          this.$message.error('delete failed');
        });
    },
    loadTemplate($event, data) {
      let img = new Image();
      img.src = data;
      const width = parseInt(img.width, 10);
      const height = parseInt(img.height, 10);
      this.$store.dispatch('elm_add', {
        type: 'image',
        width: width,
        height: height,
        isDynamic: 0,
        isCover: 0,
        x: this.canvasWidth / 2,
        y: this.canvasHeight / 2,
        content: data
      });
    },
    upload(files) {
      let _this = this;
      let arr = _.map(files, item => {
        const upload = this.handleUploadImage(item)
          .then(url => {
            this.$store.dispatch(this.namespace + '/save', { image_url: url });
          })
          .catch(e => {
            this.failure = true;
          });
        return upload;
      });
      Promise.all(arr).then(function(values) {
        _this.fetchData();
      });
    },
    async changeImage(e) {
      const files = e.target.files;
      await this.upload(files);
    },
    dragstart($event, data) {
      event.dataTransfer.setData('data', data);
      event.dataTransfer.setData('width', $event.target.naturalWidth);
      event.dataTransfer.setData('height', $event.target.naturalHeight);
    },
    dragend(event) {
      event.dataTransfer.clearData();
    }
  },
  beforeDestroy() {
    this.$store.commit(this.namespace + '/update', {
      condition: {}
    });
  },
  computed: {
    list() {
      return this.$store.state[this.namespace].list || [];
    }
  }
};
</script>

<style lang="scss" scoped>
.content {
  width: 256px;
  border-right: 1px solid #cfd3dd;
  padding: 20px;
  height: calc(100vh - 60px);
  .upload-btn {
    display: flex;
    justify-content: space-between;
    position: relative;
    align-items: center;
    .input-file {
      width: 120px;
      height: 28px;
      input {
        width: 120px;
        opacity: 0;
        position: absolute;
        z-index: 22;
        left: 0;
        height: 28px;
        line-height: 28px;
      }
      :global(.el-button) {
        position: absolute;
        left: 0;
        width: 120px;
      }
    }
    .pic-total {
      font-size: 12px;
      color: rgba(0, 0, 0, 0.35);
    }
  }
  .list {
    display: flex;
    flex-wrap: wrap;
    max-width: 100%;
    max-height: calc(100vh - 180px);
    overflow-x: hidden;
    overflow-y: scroll;
    flex-direction: row;
    justify-content: flex-start;
    > div {
      border: 1px solid #e9edf0;
      position: relative;
      object-fit: contain;
      max-width: 100%;
      margin: 4px;
      flex-grow: 1;
      box-sizing: border-box;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 4px;
      height: 83px;
      img {
        flex-grow: 1;
        height: 75px;
        max-width: 100%;
        object-fit: contain;
      }
    }

    :global(.el-checkbox) {
      position: absolute;
      top: 0;
      left: 0;
      margin: 4px 0 0 8px;
    }
    :global(.el-checkbox__input.is-checked .el-checkbox__inner) {
      background-color: #dff3ff;
    }
    :global(.el-checkbox__inner) {
      background: #dff3ff;
      border: none;
      border-radius: 2px;
      width: 16px;
      height: 16px;
      &:after {
        border: 1.13px solid #3fb7ff;
        border-radius: 1.17px;
        border-left: none;
        border-top: none;
        height: 11.15px;
        width: 5.09px;
      }
    }
  }
}

.button-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  svg {
    width: 14px;
    height: 14px;
  }
}

.batch-operate {
  font-size: 14px;
  line-height: 20px;
  color: #3fb7ff;
  margin: 19px 0 8px;
  a {
    margin-left: 4.7px;
    cursor: pointer;
  }
  .select-all {
    margin: 0 20px 0 0;
  }
  .cancel {
    color: rgba(0, 0, 0, 0.65);
  }

  &.operate-img {
    svg {
      float: right;
      margin-top: 2px;
      color: rgba(0, 0, 0, 0.65);
    }
  }
}
</style>
